import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import videoPlaceHolder from "../../assets/images/placeholder_video.png";
import imgPlaceHolder from "../../assets/images/place_photo.png";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  IconButton,
} from "@mui/material";
import { getProjectFiles } from "../../apis/apisList/userApi";
import Pagination from "@mui/material/Pagination";
import { Box, Card, CardActionArea } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import * as UTIF from "utif";
import { getConvertedImage } from "../../apis/apisList/commonApi";
import { FilePreview } from "./LazyLoadImage";

export default function ViewUserFilesDialog({ open, onClose, project, type }) {
  const [files, setFiles] = useState([]);
  const [index, setIndex] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(9);
  const [pagination, setPagination] = useState({});

  const getFiles = async (page = 1, limit = 10) => {
    try {
      let res = await getProjectFiles(project?._id, { type, page, limit });
      return res;
    } catch (error) {
      console.log("error get files", error);
      return { results: [], pagination: {} };
    }
  };
  async function validateImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(url);
      img.onerror = () => resolve("");
    });
  }

  useEffect(() => {
    if (open) {
      setLoading(true);
      getFiles(page, limit)
        .then(async (res) => {
          if (res.results?.length > 0) {
            const slides = await Promise.all(
              res.results.map(async (file) => {
                const isTiff =
                  file.type === "image" &&
                  (file.name?.toLowerCase().endsWith(".tiff") ||
                    file.name?.toLowerCase().endsWith(".tif"));
                if (isTiff) {
                  let url = getConvertedImage(file.url);
                  console.log(">>>url>>", url);
                  return {
                    src: url,
                    name: file.name,
                    width: 1200,
                    height: 800,
                    type: "image",
                    alt: "no-image",
                  };
                }

                if (file.type === "video") {
                  return {
                    type: "video",
                    width: 1920,
                    name: file.name,
                    height: 1080,
                    src: file?.thumbnail ? file.thumbnail : videoPlaceHolder,
                    poster: file?.thumbnail ? file.thumbnail : videoPlaceHolder,
                    sources: [{ src: file.url, type: "video/mp4" }],
                  };
                }
                return {
                  src: file.url,
                  name: file.name,
                  width: 1200,
                  height: 800,
                  type: "image",
                  alt: "no-image",
                };
              })
            );
            setFiles(slides || []);
            setPagination(res?.pagination);
          } else {
            setFiles([]);
          }
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          toast.error("Error fetching files");
          setLoading(false);
        });
    } else {
      setFiles([]);
      setIndex(-1);
    }
  }, [open, page]);

  if (!open) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "90vw", md: "800px" },
          height: { xs: "80vh", md: "600px" },
          maxWidth: "none",
        },
      }}
    >
      <DialogTitle
        sx={{
          width: "100%",
          maxHeight: "40px",
          fontSize: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        View Files
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "relative",
            right: 0,
            top: 0,
            ml: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <div className="simmer-gallery-custom">
            <ShimmerSimpleGallery card imageHeight={160} row={4} />
          </div>
        ) : files.length === 0 ? (
          <Typography align="center" color="text.secondary">
            No files found
          </Typography>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "flex-start",
              }}
            >
              {files.map((file, idx) => {
                const isTiff =
                  file.type === "image" &&
                  (file.name?.toLowerCase().endsWith(".tiff") ||
                    file.name?.toLowerCase().endsWith(".tif"));

                return (
                  <Box
                    key={idx}
                    sx={{
                      flex: "1 1 30%",
                      minWidth: 160,
                      maxWidth: "32%",
                      mb: 2,
                    }}
                  >
                    <Card>
                      <CardActionArea onClick={() => setIndex(idx)}>
                        <FilePreview
                          file={file}
                          videoPlaceHolder={videoPlaceHolder}
                          imgPlaceHolder={imgPlaceHolder}
                        />
                      </CardActionArea>
                    </Card>
                  </Box>
                );
              })}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", px: 3, py: 2 }}>
        <Pagination
          count={pagination?.totalPages}
          color="primary"
          onChange={(event, value) => {
            setPage(value);
          }}
        />
      </DialogActions>
      <Lightbox
        index={index}
        slides={files}
        open={index >= 0}
        close={() => setIndex(-1)}
        plugins={[Captions, Fullscreen, Slideshow, Thumbnails, Video, Zoom]}
      />
    </Dialog>
  );
}
